import { v4 as uuidv4 } from "uuid"; // Import UUID generator

export type PartnerListItem = {
    PartnerId: string;
    EmailAddress: string;
    ContactName: string;
    ContactPhone: string;
    Description: string;
    Name: string;
};

export type PartnerInfo = {
    PartnerId: string;
    EmailAddress: string;
    ContactName: string;
    ContactPhone: string;
    Description: string;
    Name: string;
};

export function newPartnerInfo(): PartnerInfo {
    return {
        PartnerId: uuidv4(), // Generate a random GUID
        EmailAddress: "",
        ContactName: "",
        ContactPhone: "",
        Description: "",
        Name: "",
    };
}